import gql from "graphql-tag";

export const createCollection = gql`
  mutation createCollection(
    $input: CreateCollectionInput!) {
    createCollection(input: $input) {
      collection {
        id
      }
      project {
        id
        collections {
          id
          index
          name
          archived
          syncing
          syncedAt
          encoding
          encodedAt
          changed
          changedAt
          searchableFields {
            field
            model
          }
        }
      }
    }
  }
`;

export const createCollectionOptions = {
  name: "createCollection",
};
